import { HomeString } from "../../utils/string";
import MachineImg from "../../assets/Images/machineImg.svg";
import { useNavigate } from "react-router-dom";

const Subheading = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-[#F2F2F2]">
        <div className="custom-container py-[65px]">
          <div className="hidden md:grid grid-cols-2 gap-8">
            <div>
              <div
                className="font-bold text-[32px] text-black cursor-pointer"
                onClick={() => navigate("/admin/add-list")}
              >
                {HomeString.List_With_Us_Today}
              </div>
              <div className="font-normal text-[24px] text-black">{HomeString.Subheading}</div>
              <div className="mt-[24px] font-normal text-[16px] text-black">{HomeString.Body_Text}</div>
              <div className="mt-[24px] font-normal text-[16px] text-black">{HomeString.Description}</div>
            </div>
            <div>
              <img src={MachineImg} alt="" width={"100%"} className="object-cover" />
            </div>
          </div>

          <div className="grid md:hidden grid-cols-1 gap-8">
            <div>
              <img src={MachineImg} alt="" width={"100%"} className="object-cover" />
            </div>
            <div>
              <div
                className="font-bold text-[32px] text-black cursor-pointer"
                onClick={() => navigate("/admin/add-list")}
              >
                {HomeString.List_With_Us_Today}
              </div>
              <div className="font-normal text-[24px] text-black">{HomeString.Subheading}</div>
              <div className="mt-[24px] font-normal text-[16px] text-black">{HomeString.Body_Text}</div>
              <div className="mt-[24px] font-normal text-[16px] text-black">{HomeString.Description}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Subheading;
